<template>
  <b-modal
    :visible.sync="visible"
    no-close-on-backdrop
    title="Cita"
    @hide="closeModal"
    size="lg"
    hide-footer
  >
    <b-card v-if="!!option" id="page-appointment-form" no-body class="mb-0">
      <b-card-header>
        <b-card-body class="p-0">
          <validation-observer ref="simpleRules">
            <b-form>
              <b-row>
                <b-col
                  cols="12"
                  md="6"
                  v-if="
                    appointment.statusHistory &&
                    appointment.statusHistory.length
                  "
                >
                  <b-list-group class="mt-1">
                    <b-list-group-item
                      class="text-center d-flex align-items-center justify-content-between"
                      @click="toggleHistoryCollapse"
                    >
                      <span>Historial de estatus</span>

                      <feather-icon
                        size="18"
                        :icon="!isHistoryCollapsed ? 'EyeOffIcon' : 'EyeIcon'"
                        :class="isHistoryCollapsed ? null : 'collapsed'"
                      />
                    </b-list-group-item>
                    <b-collapse v-model="isHistoryCollapsed" class="">
                      <b-list-group>
                        <b-list-group-item
                          v-for="status in appointment.statusHistory"
                          :key="status.idAppointmentStatusHistory"
                          :variant="status.colorStatus"
                          class="d-flex justify-content-between align-items-center"
                        >
                          <b-badge
                            pill
                            :variant="status.colorStatus"
                            class="badge-glow"
                          >
                            <span>{{ status.nameStatus }}</span>
                          </b-badge>
                          <small class="text-muted">{{
                            formatDate(status.dateUpdate)
                          }}</small>
                        </b-list-group-item>
                      </b-list-group>
                    </b-collapse>
                  </b-list-group>
                </b-col>

                <b-col v-if="option == 3" cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('status'))"
                  >
                    <b-form-group
                      :label="$t(label('status'))"
                      label-for="status"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        ref="statusSelect"
                        :key="selectKey"
                        v-model="appointment.idCatStatus"
                        input-id="status"
                        :options="allStatus"
                        label="name"
                        :placeholder="$t(label('status'))"
                        :reduce="(option) => option.id"
                        @input="confirmStatusChange"
                      >
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('typeProduct'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('typeProduct'))"
                      label-for="typeProduct"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        ref="typeProduct"
                        v-model="appointment.guidProduct"
                        input-id="typeProduct"
                        :options="productOptions"
                        label="label"
                        :placeholder="$t(label('typeProduct'))"
                        :disabled="option === 2"
                        :reduce="(option) => option.value"
                        :get-option-key="getIdentifierOptionKey"
                        :filterable="false"
                        :close-on-select="false"
                        @open="onOpenProducts"
                        @close="onCloseProducts"
                        @search="onSearchProducts"
                      >
                        <template #list-footer>
                          <li
                            v-show="productHasNextPage || productLoading"
                            ref="loadProducts"
                            class="modal-select-loader"
                          >
                            {{ $t("loadingOption") }}
                          </li>
                        </template>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('appointmentDate'))"
                    label-for="appointmentDate"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('appointmentDate'))"
                      rules="required"
                    >
                      <b-form-datepicker
                        id="appointmentDate"
                        ref="startDate"
                        v-model="appointment.appointmentDate"
                        :placeholder="$t(label('appointmentDate'))"
                        :disabled="option === 2"
                        :state="errors.length > 0 ? false : null"
                        class="mr-2"
                        reset-button
                        dropright
                        :min="new Date()"
                      >
                      </b-form-datepicker>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('appointmentTimeStar'))"
                    label-for="appointmentTimeStar"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('appointmentTimeStar'))"
                      rules="required"
                    >
                      <b-form-timepicker
                        id="appointmentTimeStar"
                        ref="startTime"
                        v-model="appointment.appointmentTimeStar"
                        :placeholder="$t(label('appointmentTimeStar'))"
                        reset-button
                        :disabled="option === 2"
                        :state="errors.length > 0 ? false : null"
                        dropright
                        @input="calculateEndTime"
                      >
                      </b-form-timepicker>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('clients'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('clients'))"
                      label-for="clients"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="appointment.clients"
                        input-id="clients"
                        :options="customerOptions"
                        label="label"
                        :get-option-key="getCustomerOptionKey"
                        :placeholder="$t(label('clients'))"
                        :disabled="option === 2"
                        :filterable="false"
                        :close-on-select="false"
                        multiple
                        @open="onOpenCustomers"
                        @close="onCloseCustomers"
                        @search="onSearchCustomers"
                      >
                        <template #list-footer>
                          <li
                            v-show="customerHasNextPage || customerLoading"
                            ref="loadCustomers"
                            class="modal-select-loader"
                          >
                            {{ $t("loadingOption") }}
                          </li>
                        </template>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('employees'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('employees'))"
                      label-for="employees"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="appointment.idEmployee"
                        input-id="employees"
                        :options="employeeOptions"
                        label="label"
                        :placeholder="$t(label('employees'))"
                        :disabled="option === 2"
                        :taggable="false"
                        :reduce="(option) => option.value"
                        :get-option-key="getIdentifierOptionKey"
                        :filterable="false"
                        :close-on-select="false"
                        @open="onOpenEmployees"
                        @close="onCloseEmployees"
                        @search="onSearchEmployees"
                      >
                        <template #list-footer>
                          <li
                            v-show="employeeHasNextPage || employeeLoading"
                            ref="loadEmployees"
                            class="modal-select-loader"
                          >
                            {{ $t("loadingOption") }}
                          </li>
                        </template>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('contact'))"
                    label-for="contactDetails"
                  >
                    <vue-tel-input
                      inputId="contactDetails"
                      name="contactDetails"
                      v-model="appointment.contactDetails"
                      :disabled="option === 2"
                      :mode="'international'"
                      defaultCountry="ve"
                      :disabledFetchingCountry="true"
                      :inputOptions="inputTelOption"
                      @open="onDropdownOpen(true)"
                      @close="onDropdownOpen(false)"
                    >
                      <template v-slot:arrow-icon>
                        <span>{{ openTelInput ? "▲" : "▼" }}</span>
                      </template>
                    </vue-tel-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('isRecurring'))"
                    label-for="isRecurring"
                  >
                    <b-form-checkbox
                      id="isRecurring"
                      v-model="appointment.isRecurring"
                      :name="$t(label('isRecurring'))"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="option === 2"
                    >
                      {{ $t(label("isRecurring")) }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6" v-if="appointment.isRecurring">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('typeCurring'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('typeCurring'))"
                      label-for="typeCurring"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="appointment.idCatRecurrencePattern"
                        input-id="typeCurring"
                        :options="listRecurrency"
                        label="name"
                        :placeholder="$t(label('typeCurring'))"
                        :disabled="option === 2"
                        :reduce="(option) => option.id"
                      >
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('notes'))" label-for="notes">
                    <b-form-textarea
                      id="notes"
                      v-model="appointment.notes"
                      :placeholder="$t(label('notes'))"
                      rows="3"
                      :disabled="option === 2"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  class="d-flex justify-content-between align-items-center"
                  cols="12"
                >
                  <b-button
                    v-if="option != 2"
                    @click="$emit('createClient', true)"
                    variant="primary"
                  >
                    <feather-icon icon="UserPlusIcon" />
                    Nuevo cliente
                  </b-button>
                  <b-button
                    v-if="option != 2"
                    type="submit"
                    :disabled="!isSave"
                    variant="primary"
                    class="mr-1"
                    @click.prevent="onSubmit"
                  >
                    {{ $t("save") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card-body>
      </b-card-header>
    </b-card>
  </b-modal>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { required, integer, min } from "@validations";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BButton,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BForm,
  BFormTextarea,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTimepicker,
  BFormCheckbox,
  BListGroup,
  BCollapse,
  BListGroupItem,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { statusChangesAppointmentProduct } from "@core/api/request/appointmentsProducts";

const appointment = {
  idAppointment: null,
  guidProduct: null,
  appointmentDate: "",
  durationMinutes: null,
  clients: [],
  idEmployee: null,
  idCatStatus: null,
  contactDetails: "",
  notes: null,
  isRecurring: false,
  idCatRecurrencePattern: null,
  endDateTime: "",

  appointmentTimeStar: "",
  appointmentTimeEnd: "",
  payments: [],
  seviceAppoimnet: null,
  statusHistory: [],
  previousStatus: null,
};

export default {
  components: {
    BButton,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BForm,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    vSelect,
    BFormInvalidFeedback,
    BFormDatepicker,
    BFormTimepicker,
    VueTelInput,
    BFormCheckbox,
    BListGroup,
    BCollapse,
    BListGroupItem,
    BBadge,
  },
  name: "EventModal",
  props: [
    "visible",
    "event",
    "employeeOptions",
    "employeeHasNextPage",
    "employeeLoading",
    "loadMoreEmployees",
    "searchEmployees",
    "productOptions",
    "productHasNextPage",
    "productLoading",
    "loadMoreProducts",
    "searchProducts",
    "customerOptions",
    "customerHasNextPage",
    "customerLoading",
    "loadMoreCustomers",
    "searchCustomers",
    "listRecurrency",
    "statusAppintments",
    "allStatus",
    "options",
  ],
  data() {
    return {
      isSave: true,
      appointment: Object.assign(appointment),
      eventCopy: { ...this.event },
      option: "",
      required,
      openTelInput: false,
      inputTelOption: {
        placeholder: "Ingrese un número de teléfono",
      },
      isHistoryCollapsed: false,
      selectKey: 0,
      previousStatusName: null,
      previousStatus: null,
      employeeObserver: null,
      employeeSearchTimer: null,
      employeeSelectOpen: false,
      productObserver: null,
      productSearchTimer: null,
      productSelectOpen: false,
      customerObserver: null,
      customerSearchTimer: null,
      customerSelectOpen: false,
    };
  },
  watch: {
    event: {
      immediate: true,
      handler(val) {
        this.appointment = Object.assign(this.appointment, {
          idAppointment: val.idAppointment,
          guidProduct: val.guidProduct,
          appointmentDate: val.appointmentDate,
          durationMinutes: val.durationMinutes,
          clients: val.clients,
          idEmployee: val.idEmployee,
          idCatStatus: val.catStatus,
          contactDetails: val.contactDetails,
          notes: val.notes,
          isRecurring: val.isRecurring,
          idCatRecurrencePattern: val.idCatRecurrencePattern,
          endDateTime: val.endDateTime,
          employee: val.employee,
          appointmentTimeStar: val.appointmentTimeStar,
          appointmentTimeEnd: val.appointmentTimeEnd,
          payments: [],

          productAppoimnet: val.productAppoimnet,
          statusHistory: val.statusHistory || [],
        });
        this.previousStatusName = val.catStatus ? val.catStatus?.name : "";
        this.previousStatus = val.catStatus ? val.catStatus : "";
      },
    },
    options: {
      immediate: true,
      handler(val) {
        this.isSave = true;
        this.option = val;
      },
    },
  },

  async created() {
    localize("es");
    this.onCancel();
    // await Promise.all([this.loadRecurrency(), this.loadStatus()]);
  },

  mounted() {
    if (typeof IntersectionObserver !== "undefined") {
      this.employeeObserver = new IntersectionObserver(
        this.infiniteScrollEmployees,
      );
      this.productObserver = new IntersectionObserver(
        this.infiniteScrollProducts,
      );
      this.customerObserver = new IntersectionObserver(
        this.infiniteScrollCustomers,
      );
    }
  },

  beforeDestroy() {
    if (this.employeeObserver) this.employeeObserver.disconnect();
    if (this.productObserver) this.productObserver.disconnect();
    if (this.customerObserver) this.customerObserver.disconnect();
    clearTimeout(this.employeeSearchTimer);
    clearTimeout(this.productSearchTimer);
    clearTimeout(this.customerSearchTimer);
  },

  methods: {
    getIdentifierOptionKey(option) {
      const identifier =
        option && typeof option === "object" ? option.value : option;
      return identifier == null
        ? identifier
        : String(identifier).trim().toLowerCase();
    },

    getCustomerOptionKey(option) {
      return option && option.idClient != null
        ? String(option.idClient)
        : option?.label;
    },
    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // this.isSave = false;
          const catStatus =
            this.option === 1
              ? _.find(this.statusAppintments, function (item) {
                  return item.name.toLowerCase() === "programada";
                })?.id
              : typeof this.appointment.idCatStatus === "object"
              ? this.appointment.idCatStatus.id
              : this.appointment.idCatStatus;

          // this.appointment.clients = this.appointment.clients.map((idCli) => ({
          //   idClient: idCli.idClient || idCli,
          // }));

          this.$emit("save", this.appointment, catStatus);
        }
      });
    },

    closeModal() {
      this.isSave = true;
      this.$emit("close");
      this.onCancel();
    },

    // loadRecurrency() {
    //   const arrParams = getParams([
    //     `itemsPage,1`,
    //     `itemsRows,999`,
    //     `guidCatalog,cb709850-b958-4596-9be9-1d76aacd1950`,
    //   ]);
    //   getCatalog(arrParams)
    //     .then((resp) => {
    //       const data = _.get(resp, "data") || [];
    //       this.listRecurrency = data.listOfItems.items;
    //       console.log(this.listRecurrency);
    //     })
    //     .catch((error) => {
    //       this.alertToast("danger", error.message);
    //     });
    // },

    // loadStatus() {
    //   const arrParams = getParams([
    //     `itemsPage,1`,
    //     `itemsRows,999`,
    //     `guidCatalog,4018795c-bd02-44a5-b2b9-494cdf6bc6c9`,
    //   ]);
    //   getCatalog(arrParams)
    //     .then((resp) => {
    //       stopLoading();
    //       const data = _.get(resp, "data.listOfItems") || [];
    //       this.statusAppintments = data.items;
    //       this.allStatus = data.items.filter(
    //         (item) => item.name.toLowerCase() !== "programada"
    //       );
    //       console.log(
    //         "getCatalog",
    //         this.statusAppintments,
    //         data.items,
    //         this.allStatus
    //       );
    //     })
    //     .catch((error) => {
    //       stopLoading();
    //     });
    // },

    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },

    onOpenEmployees() {
      return this.openRemoteSelect("employee");
    },
    onCloseEmployees() {
      this.closeRemoteSelect("employee");
    },
    onSearchEmployees(query) {
      this.searchRemoteSelect("employee", query, this.searchEmployees);
    },
    infiniteScrollEmployees(entries) {
      return this.infiniteScrollRemote("employee", entries, this.loadMoreEmployees);
    },

    onOpenProducts() {
      return this.openRemoteSelect("product");
    },
    onCloseProducts() {
      this.closeRemoteSelect("product");
    },
    onSearchProducts(query) {
      this.searchRemoteSelect("product", query, this.searchProducts);
    },
    infiniteScrollProducts(entries) {
      return this.infiniteScrollRemote("product", entries, this.loadMoreProducts);
    },

    onOpenCustomers() {
      return this.openRemoteSelect("customer");
    },
    onCloseCustomers() {
      this.closeRemoteSelect("customer");
    },
    onSearchCustomers(query) {
      this.searchRemoteSelect("customer", query, this.searchCustomers);
    },
    infiniteScrollCustomers(entries) {
      return this.infiniteScrollRemote("customer", entries, this.loadMoreCustomers);
    },

    async openRemoteSelect(type) {
      this[`${type}SelectOpen`] = true;
      await this.observeRemoteLoader(type);
    },

    closeRemoteSelect(type) {
      this[`${type}SelectOpen`] = false;
      clearTimeout(this[`${type}SearchTimer`]);
      const observer = this[`${type}Observer`];
      if (observer) observer.disconnect();
    },

    searchRemoteSelect(type, query, searchMethod) {
      clearTimeout(this[`${type}SearchTimer`]);
      this[`${type}SearchTimer`] = setTimeout(async () => {
        if (typeof searchMethod === "function") {
          await searchMethod(query);
        }
        await this.observeRemoteLoader(type);
      }, 300);
    },

    getRemoteSelectState(type) {
      const plural =
        type === "employee"
          ? "Employees"
          : type === "product"
          ? "Products"
          : "Customers";
      return {
        hasNextPage: this[`${type}HasNextPage`],
        loading: this[`${type}Loading`],
        observer: this[`${type}Observer`],
        isOpen: this[`${type}SelectOpen`],
        refName: `load${plural}`,
      };
    },

    async observeRemoteLoader(type) {
      const state = this.getRemoteSelectState(type);
      if (!state.isOpen || !state.observer || !state.hasNextPage) return;
      await this.$nextTick();
      const target = this.$refs[state.refName];
      if (target) {
        state.observer.disconnect();
        state.observer.observe(target);
      }
    },

    async infiniteScrollRemote(type, [{ isIntersecting, target }], loadMore) {
      const state = this.getRemoteSelectState(type);
      if (!isIntersecting || state.loading || !state.hasNextPage) return;
      const list = target.offsetParent;
      const scrollTop = list ? list.scrollTop : 0;
      if (typeof loadMore === "function") await loadMore();
      await this.$nextTick();
      if (list) list.scrollTop = scrollTop;
      await this.observeRemoteLoader(type);
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    label(field) {
      return `pages.productAppointments.form.label.${field}`;
    },

    toggleHistoryCollapse() {
      this.isHistoryCollapsed = !this.isHistoryCollapsed;
    },

    // this.$emit("close"); createClient

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    calculateEndTime() {
      const { appointmentTimeStar, durationMinutes } = this.appointment;
      if (appointmentTimeStar && durationMinutes && durationMinutes > 0) {
        const [hours, minutes] = appointmentTimeStar.split(":").map(Number);
        const startDateTime = new Date();
        startDateTime.setHours(hours);
        startDateTime.setMinutes(minutes);

        startDateTime.setMinutes(
          startDateTime.getMinutes() + Number(durationMinutes),
        );

        const endHours = String(startDateTime.getHours()).padStart(2, "0");
        const endMinutes = String(startDateTime.getMinutes()).padStart(2, "0");

        this.$set(
          this.appointment,
          "appointmentTimeEnd",
          `${endHours}:${endMinutes}`,
        );
      } else {
        this.$set(this.appointment, "appointmentTimeEnd", null);
      }
    },

    confirmStatusChange(newStatus) {
      console.log("Nuevo estatus seleccionado:", this.appointment);
      const appointmentDetails = [
        {
          labelKey: "dse",
          value: this.appointment.productAppoimnet.name || "",
        },
        {
          labelKey: "appointmentDate",
          value: this.formatDate(this.appointment.appointmentDate),
        },
        {
          labelKey: "from",
          value: this.formatTime(this.appointment.appointmentDate),
        },
        {
          labelKey: "to",
          value: this.formatTime(this.appointment.endDateTime),
        },
        {
          labelKey: "client",
          value:
            Array.isArray(this.appointment.clients) &&
            this.appointment.clients.length
              ? this.appointment.clients
                  .map((c) => this.getClientFullName(c))
                  .join(", ")
              : "",
        },
        {
          labelKey: "attendedby",
          value: this.appointment.employee || "",
        },
        {
          labelKey: "status",
          value: this.previousStatusName,
        },
      ];

      const htmlContent = `
        <div style="text-align: left;">
          ${appointmentDetails
            .filter((detail) => detail.value)
            .map(
              (detail) => `
                <span class="font-weight-bolder">${this.$t(
                  this.label(detail.labelKey),
                )}:</span> ${detail.value} <br/>
              `,
            )
            .join("")}
        </div>
      `;

      this.$swal({
        title: `<span class="sweet-title">Confirmar cambio de estatus</span>`,
        html: htmlContent,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: "sweet-appointment-container",
          popup: "sweet-appointment-popup",
          header: "sweet-appointment-header",
          title: "sweet-appointment-title",
          htmlContainer: "sweet-appointment-content",
          actions: "sweet-appointment-actions",
          confirmButton: "btn btn-primary sweet-btn sweet-btn-confirm",
          denyButton: "btn btn-danger sweet-btn sweet-btn-deny",
          cancelButton: "btn btn-outline-secondary sweet-btn sweet-btn-cancel",
        },
        buttonsStyling: false,
        allowOutsideClick: true,
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
        preConfirm: () => {
          return this.updateStatus(newStatus);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("close");
        } else {
          // Si se cierra o cancela, revertimos el select a previousStatus
          this.restorePreviousStatus();
        }
      });
    },

    restorePreviousStatus() {
      this.appointment.idCatStatus = this.previousStatus;
      this.selectKey += 1;
    },

    async updateStatus(newStatus) {
      try {
        const status = {
          idAppointment: this.appointment.idAppointment,
          idCatStatus: newStatus,
        };

        const response = await statusChangesAppointmentProduct(status);

        if (response.err) {
          throw new Error("Error al actualizar el estatus");
        }

        this.previousStatus = newStatus;
        this.alertToast("success", "Estatus actualizado exitosamente");
        this.selectKey += 1;
      } catch (error) {
        this.alertToast(
          "danger",
          error.message || "Error al actualizar el estatus",
        );
        this.appointment.idCatStatus = this.previousStatus;
        this.selectKey += 1;
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    formatTime(dateString) {
      return moment(dateString).format("hh:mm A");
    },

    getClientFullName(client) {
      // return `${client.name} ${client.lastName != null ? client.lastName : ""}`;
      if (!client) return "";
      // Prefer label if present
      if (typeof client === "object") {
        if (client.label) return client.label;
        return `${client.name || ""} ${
          client.lastName ? client.lastName : ""
        }`.trim();
      }
      // If client is an id, look up in customerOptions
      const found = this.customerOptions?.find(
        (c) => c.idClient === client || c.idClient === Number(client),
      );
      if (found) {
        if (found.label) return found.label;
        return `${found.name || ""} ${
          found.lastName ? found.lastName : ""
        }`.trim();
      }
      return "";
    },

    onCancel() {
      if (this.$refs.simpleRules) {
        this.$refs.simpleRules.reset();
      }
      this.appointment = Object.assign({
        idAppointment: null,
        guidProduct: null,
        appointmentDate: "",
        durationMinutes: null,
        clients: [],
        idEmployee: null,
        idCatStatus: null,
        contactDetails: "",
        notes: null,
        isRecurring: false,
        idCatRecurrencePattern: null,
        endDateTime: "",

        appointmentTimeStar: "",
        appointmentTimeEnd: "",
        payments: [],
        productAppoimnet: null,
        statusHistory: [],
        previousStatus: null,
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title,
          icon:
            type == "danger"
              ? "XIcon"
              : type == "success"
              ? "CheckIcon"
              : "AlertTriangleIcon",
          variant: type,
          text: message,
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-select-loader {
  padding: 0.75rem;
  color: #b9b9c3;
  text-align: center;
}
</style>
